import React from "react";
import { useToast } from "../../Common/hooks/useToast";
import { BottomNav } from "../../Common/custom_components/bottom_nav/BottomNav";
import { useDocumentsModule } from "./hooks/documents_module.hook";
import style from "./documents.module.css";

export const DoctorDocuments: React.FC = () => {
  const { toast } = useToast();
  const { documents, isLoading, handleOpenDocument, getDocIcon, formatDocType, navigate } = useDocumentsModule();

  return (
    <div className={style.doctorBody}>
      {toast.show && (
        <div className={`${style.toastMsg} ${style.show} ${style[toast.type]}`}>
          <span className="material-icons-round">
            {toast.type === "success" ? "check_circle" : "error"}
          </span>
          {toast.msg}
        </div>
      )}

      {/* Header */}
      <div className={style.docHeader}>
        <div className={style.docHeaderLeft}>
          <button className={style.docHeaderBack} onClick={() => navigate("/profile")}>
            <span className="material-icons-round">arrow_back</span>
          </button>
          <div className={style.docHeaderInfo} style={{ marginLeft: "12px" }}>
            <h1 style={{ fontSize: "16px" }}>My Documents</h1>
          </div>
        </div>
      </div>

      <div className={style.docContent} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div className={style.infoCard}>
          <h3>Uploaded Documents</h3>
          {isLoading ? (
            <div style={{ textAlign: "center", padding: "24px", color: "var(--primary)", fontWeight: 600 }}>
              Loading documents...
            </div>
          ) : documents.length === 0 ? (
            <div style={{ textAlign: "center", padding: "24px", color: "var(--on-surface-variant)" }}>
              No documents uploaded yet.
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "12px" }}>
              {documents.map((doc) => (
                <div
                  key={doc._id}
                  style={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    padding: "12px 14px", borderRadius: "12px",
                    background: "var(--surface-container)", border: "1px solid var(--outline)",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{
                      width: "40px", height: "40px", borderRadius: "8px",
                      background: "var(--primary-container)", color: "var(--primary)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      <span className="material-icons-round">{getDocIcon(doc.document_type)}</span>
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: "14px", color: "var(--on-surface)" }}>
                        {formatDocType(doc.document_type)}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "4px", marginTop: "2px" }}>
                        <span
                          className="material-icons-round"
                          style={{ fontSize: "14px", color: doc.verified ? "#10B981" : "#F59E0B" }}
                        >
                          {doc.verified ? "verified" : "pending_actions"}
                        </span>
                        <span style={{ fontSize: "12px", color: "var(--on-surface-variant)" }}>
                          {doc.verified ? "Verified" : "Pending Verification"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => handleOpenDocument(doc.document_url)}
                    style={{
                      width: "36px", height: "36px", borderRadius: "50%",
                      background: "var(--white)", border: "1px solid var(--outline)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: "var(--on-surface)", cursor: "pointer",
                    }}
                  >
                    <span className="material-icons-round" style={{ fontSize: "20px" }}>open_in_new</span>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <BottomNav />
    </div>
  );
};
